"use client";
const ProgressBar = ({ name, value }) => {
  const percentage = parseFloat(value);

  let colorClass = "bg-gray-300";
  let negativeClass = "bg-red-700";
  if (percentage) {
    colorClass = "bg-green-500";
  }

  return (
    <>
      <div className="py-1 w-[335px]">
        <div className="flex justify-between">
          <p className="text-xs font-semibold text-[#333333] mb-1 basis-[80%]">
            {name}
          </p>
          <p className="font-semibold text-xs text-[#333333]">{value} %</p>
        </div>
        <div className="h-[6px] relative bg-gray-300 rounded-full">
          <div
            className={`h-[6px] ${
              Math.sign(percentage) === -1 ? negativeClass : colorClass
            } rounded-full`}
            style={{ width: `${percentage}%` }}
          ></div>
        </div>
      </div>
    </>
  );
};

export default ProgressBar;
